export default __webpack_public_path__ + "static/media/air-cooled-chiller.404e9e54.jpg";